import React from 'react';
import { Button, Icon, Text } from '@spothero/ui';
import { useMobileViewToggle } from 'pages/search/components/search-component/mobile-view-toggle/hooks/use-mobile-view-toggle';
const ToggleOption = ({ IconOption, label, onClick }) => (<Button key={label} onClick={onClick} variant="secondary" paddingLeft="3" rounded="md" marginLeft="2" paddingY="2" paddingX="3" data-testid={`mobile-view-toggle-${label.toLowerCase()}`}>
        <Icon as={IconOption} height="4" width="4"/>
        <Text paddingLeft="1" fontWeight="semibold" fontSize="sm">
            {label}
        </Text>
    </Button>);
export default function MobileViewToggle() {
    const { handleClick, activeOption } = useMobileViewToggle();
    return <ToggleOption onClick={handleClick} {...activeOption}/>;
}
